module.exports = __webpack_public_path__ + "img/shilaohuagaizao_fwsrz.8fd9f1cd.png";